<button class="result-button">
  <mat-card
    class="result-card"
    [ngClass]="{ 'in-cart': !!data.amount && !isSortiment }"
    (click)="openProductModal()"
  >
    <div
      *ngIf="!!data.amount && !isSortiment"
      class="in-cart-status d-flex justify-content-center pb-3 pt-2"
    >
      <mat-icon fontSet="material-icons-outlined" class="shopping-cart-icon"
        >shopping_cart</mat-icon
      >{{ "Kosárban található: " + (this.quantity ? data.amount : 0) + "db" }}
    </div>
    <div
      class="result-card__image-btn spinner-container"
      [style.background]="data.images ?? [] | defaultImage: imageBaseUrl"
    >
      <ng-container *ngIf="!data.images?.length">
        {{ DICT_PATH + "NO_IMAGE" | translate }}
      </ng-container>
      <app-drs-fee-logo *ngIf="data.additionalDepositFee" class="drs_logo">
      </app-drs-fee-logo>
    </div>

    <div class="result-card__name-container">
      <!-- [routerLink]="'/buying/search/view'"
    [queryParams]="{ id: data.packagingUnitId }" -->
      <span
        #cardTitle
        [matTooltip]="
          isVerticalEllipsisActive(cardTitle) ? data.label ?? '' : ''
        "
      >
        {{ data.label }}
      </span>
    </div>
    <div class="result-card__pricing d-flex flex-column">
      <ng-container>
        <span
          *ngIf="data.discountedPrice && data.discountType; else originalPrice"
          class="main-price discounted"
          >{{ "SHARED." + data.discountType | translate }}:
          {{ data.discountedPrice.grossPrice | number: "0.0-0" }} Ft-tól
          <span class="vat-price"
            >({{ data.discountedPrice.netPrice | number: "0.0-0" }} Ft +
            ÁFA)</span
          >
        </span>
        <ng-template #originalPrice>
          <span *ngIf="data.originalPrice?.grossPrice" class="main-price"
            >{{ data.originalPrice?.grossPrice | number: "0.0-0" }} Ft-tól
            <span class="vat-price"
              >({{ data.originalPrice?.netPrice | number: "0.0-0" }} Ft +
              ÁFA)</span
            >
          </span>
        </ng-template>
      </ng-container>
    </div>
    <div
      class="result-card__actions d-flex flex-column"
      (click)="$event.stopPropagation()"
    >
      <div
        [matTooltip]="DICT_PATH + 'NO_PRICE_TOOLTIP' | translate"
        [matTooltipDisabled]="!!data.originalPrice?.grossPrice"
        *ngIf="!isSortiment; else sortimentButton"
      >
        <button
          *ngIf="!data.amount; else selectAmount"
          class="w-100"
          mat-raised-button
          (click)="addToCart()"
          [disabled]="!data.originalPrice?.grossPrice"
          color="primary"
        >
          {{ DICT_PATH + "ADD_TO_CART" | translate }}
        </button>
        <ng-template #selectAmount>
          <mat-card class="select-amount-container my-0 d-flex">
            <button type="button" (click)="removeOneItemToCart()">
              <mat-icon>remove</mat-icon>
            </button>
            <input
              (blur)="onInputBlur()"
              (ngModelChange)="onQuantityChange($event)"
              [(ngModel)]="quantity"
              matInput
              type="number"
              appLimitDecimalDigits
              [decimals]="0"
              [isNumberInput]="true"
              (wheel)="$event.preventDefault()"
            />
            <button type="button" (click)="addOneItemToCart()">
              <mat-icon>add</mat-icon>
            </button>
          </mat-card>
        </ng-template>
      </div>
      <ng-template #sortimentButton>
        <button mat-raised-button (click)="addSortiment()" color="primary">
          {{ DICT_PATH + "ADD_SORTIMENT" | translate }}
        </button>
      </ng-template>
    </div>
  </mat-card>
</button>
